import { Component, OnInit, inject } from '@angular/core';
import {AddressType} from '../shared/address-type';
import {IsoApi} from '@shared/api/iso.api';
import {IsoCountry} from '@shared/objects/iso-country';
import {AddressTypeApi} from '../shared/address-type.api';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {InfoApi} from '@shared/api/info.api';
import { ToastrService } from 'ngx-toastr';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SessionService} from "@shared/services/session.service";
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'address-dialog.component.html',
    styleUrls: ['address-dialog.component.scss'],
    imports: [MatCard, ReactiveFormsModule, MatToolbar, MatSlideToggle, MatTooltip, MatCardContent, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatCardActions, MatButton]
})
export class AddressDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddressDialogComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  private infoApi = inject(InfoApi);
  private addressTypeApi = inject(AddressTypeApi);
  private sessionService = inject(SessionService);
  private toastrService = inject(ToastrService);
  data = inject(MAT_DIALOG_DATA);

  addressTypes: AddressType[];
  countries: IsoCountry[];
  editAddressForm: UntypedFormGroup;

  constructor() {
    const isoApi = inject(IsoApi);
    const data = this.data;

    isoApi.countries().subscribe(countries => {
      this.countries = countries;
    });

    this.createForm();

    this.editAddressForm.patchValue(data.address.getRawValue());

    this.editAddressForm.controls['zip'].valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => this.onLookupAddress());

    this.editAddressForm.controls['housenumber'].valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => this.onLookupAddress());
  }

  ngOnInit(): void {
    this.addressTypeApi.findAll().subscribe(addressTypes => {
      this.addressTypes = addressTypes;
      if (this.editAddressForm.value && !this.editAddressForm.value.typeId) {
        this.editAddressForm.patchValue({typeId: addressTypes[0].id});
      }
    });
  }

  createForm() {
    this.editAddressForm = this.formBuilder.group({
      id: [],
      typeId: [null, Validators.required],
      street: [null, Validators.required],
      housenumber: [null, Validators.required],
      zip: [null, Validators.required],
      city: [null, Validators.required],
      isoCountryId: [this.sessionService.session.administration.isoCountryId, Validators.required],
      standard: [false],
    });
  }

  onLookupAddress() {
    const zip = (this.editAddressForm.value.zip ?? '').trim();
    const houseNo = (this.editAddressForm.value.housenumber ?? '').trim();

    if (zip && houseNo) {
      this.infoApi.bag(zip.replace(' ', ''), houseNo).subscribe(value => {
        if (value && value.length > 0) {
          this.editAddressForm.patchValue({
            street: value[0].street,
            city: value[0].city
          }, {emitEvent: false});
        } else {
          const message = `Adres niet gevonden voor ${zip} en ${houseNo}.`;
          this.toastrService.info(message, 'Adres niet gevonden');
        }
      });
    }
  }

  onSave() {
    if(this.editAddressForm.valid) {
      this.dialogRef.close(this.editAddressForm.value);
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
